import React, { Component } from "react";
import { connect } from 'react-redux';
import FileUpload from "components/Upload/FileUpload";
import ImagePreview from "components/Upload/ImagePreview"; 
import { helperFunctions as HF } from 'helper/helperFunctions';
import { Card } from "components/Card/Card.jsx";
import { festivalActions } from 'redux/actions/festival-action';
import ReactLoading from 'react-loading';

class MDMediaFormPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
	      	uploadFiles : [],
	      	allowedMimes : 'audio/* , video/*',
			allowedFormatsStringExt : 'audio, video',
		}
	}
	setResourceFile = (key, value) => {
		console.log('value', value);
		this.setState({
			uploadFiles: [...this.state.uploadFiles, value ],
		}, ()=>{
			console.log('upload files', this.state.uploadFiles);
		});
	}
	updateResourceFile = (index, fileObject) =>{
		const uploadFilesState =  [...this.state.uploadFiles];
	    uploadFilesState[index] = fileObject;
	    this.setState({
	    	uploadFiles: uploadFilesState,
	    });
	}
	removeFile = (key, index) =>{
		const uploadFilesState =  [...this.state.uploadFiles]
		uploadFilesState.splice(index, 1);
		this.setState({
	    	uploadFiles: uploadFilesState,
	    });
	}
	clearAllTempImages = () => {
		this.setState({
	    	uploadFiles: [],
	    });
	}
	saveImages = () => {
		const fd = new FormData();
		this.state.uploadFiles.forEach((file) => {
            fd.append('MDfiles[]', file);
        });
		this.props.storeMDMediaCall(this.props.mdId, fd).then(
			response=>{
				this.props.closeModel();
			}
		)
	}
	render() {
		const { allowedFormatsStringExt, allowedMimes, uploadFiles } = this.state;
		const { loading } = this.props;
		return(
			<div>
				{/*<Card bsClass={["innerCard"]} title={loading?'Uploading Files':'Upload Files'} collapseTrigger={this.state.collapseImageUploaderAndViewer} collapsHandler={() => this.setState({ collapseImageUploaderAndViewer: !this.state.collapseImageUploaderAndViewer })} collapsable={true}
					content={*/}
						<div>
							
							{
								!loading &&
								<React.Fragment>
									<span className="customUploader mediaUploader"></span>
									<FileUpload 
										files={uploadFiles} 
										setResourceFile={this.setResourceFile}
										updateResourceFile={this.updateResourceFile}
										allowedMimesPro={allowedMimes} 
										allowedFormatsStringExtPro={allowedFormatsStringExt}
										askToUpdate={false}
										updateWithoutAsking={true}
										allowDuplicate={false}
										multiple={true}
									/>
								</React.Fragment>
							}
							<ImagePreview 
								filesToPreview={uploadFiles}
								removeFile={this.removeFile}
								loading={loading}
							/>
							<div className="clearfix mb-md mt-sm text-center">
								{
									!loading && uploadFiles.length > 0 &&
									<button type="button" className="btn btn-info" onClick={this.saveImages}>Save</button>
								}
								{
									!loading && uploadFiles.length > 0 &&
									<button type="button" className="ml-sm btn btn-info"  onClick={this.clearAllTempImages}>Clear All</button>
								}
								{ 
									loading &&
									<ReactLoading type="bars" color="#1DC7EA" height={5} width={40} className="pull-right mb-sm" />	
								}
							</div>
						</div>
					{/*}}/>*/}
			</div>
		);
	}
}

const mapDispatchToProps = dispatch => {
	return ({
		storeMDMediaCall: (MDId, mediaData) => { return dispatch(festivalActions.storeMDMedia(MDId, mediaData)) },//example function
	});
};

function mapStateToProps(state) {
	const { loading } = state.festivalReducer;
	return {
		loading
	};
}


const MDMediaForm = connect(mapStateToProps, mapDispatchToProps)(MDMediaFormPage);
export default MDMediaForm;


// WEBPACK FOOTER //
// ./src/components/Admin/FestivalMusicDirector/MDMediaForm.jsx